//action types
import { INIT_BTAX_DATA } from "../Actions/actionTypes";

const INITIAL_STATE = {
  btaxData: "",
  isBtaxClient: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INIT_BTAX_DATA:
      return { ...state, btaxData: action.payload, isBtaxClient: true };

    default:
      return { ...state };
  }
};
